import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Project Organization
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type ProjectsParameters = ProjectsProjectCreatedParameters | ProjectsProjectArchivedParameters | ProjectsProjectUnarchivedParameters | ProjectsProjectDeletedParameters | ProjectsProjectNoteUpdatedParameters | ProjectsProjectStatusUpdatedParameters | ProjectsProjectFilterUpdatedParameters | ProjectsProjectSortUpdatedParameters | ProjectsProjectGroupingUpdatedParameters | ProjectsProjectFilterpaywallOpenedParameters | ProjectsProjectstatusPaywallOpenedParameters;
export type ProjectsEvents = ProjectsProjectCreatedEvent | ProjectsProjectArchivedEvent | ProjectsProjectUnarchivedEvent | ProjectsProjectDeletedEvent | ProjectsProjectNoteUpdatedEvent | ProjectsProjectStatusUpdatedEvent | ProjectsProjectFilterUpdatedEvent | ProjectsProjectSortUpdatedEvent | ProjectsProjectGroupingUpdatedEvent | ProjectsProjectFilterpaywallOpenedEvent | ProjectsProjectstatusPaywallOpenedEvent;

export interface ProjectsProjectCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	type: string; // project type, possible values: "project", "folder"
}

export type ProjectsProjectCreatedParametersSpecific = Omit<
	ProjectsProjectCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectsProjectCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectsProjectCreatedEventBuilder {
	constructor(private specificParameters: ProjectsProjectCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectsProjectCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectsProjectCreatedParametersSpecific,
            ProjectsProjectCreatedParameters,
			(params: ProjectsProjectCreatedParameters) => ProjectsProjectCreatedEvent
		>(this.specificParameters, projectsProjectCreatedParametersGlobal, globalParams, (params) => new ProjectsProjectCreatedEvent(params));
	}
}

/**
 * A user created a new project or project folder. The type distinguishes between the two.
 */
export class ProjectsProjectCreatedEvent extends CraftnoteEvent<ProjectsProjectCreatedParameters>{
  constructor(parameters: ProjectsProjectCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "add_project"
		},
		{
			name: "iterable",
			eventName: "projects_project_created"
		},
	]);
  }
}
export interface ProjectsProjectArchivedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	type: string; // project type, possible values: "project", "folder"
}

export type ProjectsProjectArchivedParametersSpecific = Omit<
	ProjectsProjectArchivedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectsProjectArchivedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectsProjectArchivedEventBuilder {
	constructor(private specificParameters: ProjectsProjectArchivedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectsProjectArchivedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectsProjectArchivedParametersSpecific,
            ProjectsProjectArchivedParameters,
			(params: ProjectsProjectArchivedParameters) => ProjectsProjectArchivedEvent
		>(this.specificParameters, projectsProjectArchivedParametersGlobal, globalParams, (params) => new ProjectsProjectArchivedEvent(params));
	}
}

/**
 * A user archived a project or project folder.
 */
export class ProjectsProjectArchivedEvent extends CraftnoteEvent<ProjectsProjectArchivedParameters>{
  constructor(parameters: ProjectsProjectArchivedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "archive_project_or_folder"
		},
		{
			name: "iterable",
			eventName: "projects_project_archived"
		},
	]);
  }
}
export interface ProjectsProjectUnarchivedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	type: string; // project type, possible values: "project", "folder"
}

export type ProjectsProjectUnarchivedParametersSpecific = Omit<
	ProjectsProjectUnarchivedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectsProjectUnarchivedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectsProjectUnarchivedEventBuilder {
	constructor(private specificParameters: ProjectsProjectUnarchivedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectsProjectUnarchivedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectsProjectUnarchivedParametersSpecific,
            ProjectsProjectUnarchivedParameters,
			(params: ProjectsProjectUnarchivedParameters) => ProjectsProjectUnarchivedEvent
		>(this.specificParameters, projectsProjectUnarchivedParametersGlobal, globalParams, (params) => new ProjectsProjectUnarchivedEvent(params));
	}
}

/**
 * A user unarchived a project or project folder.
 */
export class ProjectsProjectUnarchivedEvent extends CraftnoteEvent<ProjectsProjectUnarchivedParameters>{
  constructor(parameters: ProjectsProjectUnarchivedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "unarchive_project"
		},
		{
			name: "iterable",
			eventName: "projects_project_unarchived"
		},
	]);
  }
}
export interface ProjectsProjectDeletedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	type: string; // project type, possible values: "project", "folder"
}

export type ProjectsProjectDeletedParametersSpecific = Omit<
	ProjectsProjectDeletedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectsProjectDeletedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectsProjectDeletedEventBuilder {
	constructor(private specificParameters: ProjectsProjectDeletedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectsProjectDeletedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectsProjectDeletedParametersSpecific,
            ProjectsProjectDeletedParameters,
			(params: ProjectsProjectDeletedParameters) => ProjectsProjectDeletedEvent
		>(this.specificParameters, projectsProjectDeletedParametersGlobal, globalParams, (params) => new ProjectsProjectDeletedEvent(params));
	}
}

/**
 * A user deleted a project or project folder
 */
export class ProjectsProjectDeletedEvent extends CraftnoteEvent<ProjectsProjectDeletedParameters>{
  constructor(parameters: ProjectsProjectDeletedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "delete_project_or_folder"
		},
		{
			name: "iterable",
			eventName: "projects_project_deleted"
		},
	]);
  }
}
export interface ProjectsProjectNoteUpdatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
}

export type ProjectsProjectNoteUpdatedParametersSpecific = Omit<
	ProjectsProjectNoteUpdatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectsProjectNoteUpdatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectsProjectNoteUpdatedEventBuilder {
	constructor(private specificParameters: ProjectsProjectNoteUpdatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectsProjectNoteUpdatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectsProjectNoteUpdatedParametersSpecific,
            ProjectsProjectNoteUpdatedParameters,
			(params: ProjectsProjectNoteUpdatedParameters) => ProjectsProjectNoteUpdatedEvent
		>(this.specificParameters, projectsProjectNoteUpdatedParametersGlobal, globalParams, (params) => new ProjectsProjectNoteUpdatedEvent(params));
	}
}

/**
 * A user updated a project note. This can happen from the chat or the project details.
 */
export class ProjectsProjectNoteUpdatedEvent extends CraftnoteEvent<ProjectsProjectNoteUpdatedParameters>{
  constructor(parameters: ProjectsProjectNoteUpdatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "change_project_note"
		},
		{
			name: "iterable",
			eventName: "projects_project_note_updated"
		},
	]);
  }
}
export interface ProjectsProjectStatusUpdatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	isInitial: boolean; // whether the status was set before
}

export type ProjectsProjectStatusUpdatedParametersSpecific = Omit<
	ProjectsProjectStatusUpdatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectsProjectStatusUpdatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectsProjectStatusUpdatedEventBuilder {
	constructor(private specificParameters: ProjectsProjectStatusUpdatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectsProjectStatusUpdatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectsProjectStatusUpdatedParametersSpecific,
            ProjectsProjectStatusUpdatedParameters,
			(params: ProjectsProjectStatusUpdatedParameters) => ProjectsProjectStatusUpdatedEvent
		>(this.specificParameters, projectsProjectStatusUpdatedParametersGlobal, globalParams, (params) => new ProjectsProjectStatusUpdatedEvent(params));
	}
}

/**
 * A user updates the status of a project
 */
export class ProjectsProjectStatusUpdatedEvent extends CraftnoteEvent<ProjectsProjectStatusUpdatedParameters>{
  constructor(parameters: ProjectsProjectStatusUpdatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "projectStatus_change_filled"
		},
		{
			name: "iterable",
			eventName: "projects_project_status_updated"
		},
	]);
  }
}
export interface ProjectsProjectFilterUpdatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	filterType: string; // The type of filter applied, possible values are: "startDate", "endDate", "status", "employees" and "folders"
}

export type ProjectsProjectFilterUpdatedParametersSpecific = Omit<
	ProjectsProjectFilterUpdatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectsProjectFilterUpdatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectsProjectFilterUpdatedEventBuilder {
	constructor(private specificParameters: ProjectsProjectFilterUpdatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectsProjectFilterUpdatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectsProjectFilterUpdatedParametersSpecific,
            ProjectsProjectFilterUpdatedParameters,
			(params: ProjectsProjectFilterUpdatedParameters) => ProjectsProjectFilterUpdatedEvent
		>(this.specificParameters, projectsProjectFilterUpdatedParametersGlobal, globalParams, (params) => new ProjectsProjectFilterUpdatedEvent(params));
	}
}

/**
 * A user updates the filter for a project list
 */
export class ProjectsProjectFilterUpdatedEvent extends CraftnoteEvent<ProjectsProjectFilterUpdatedParameters>{
  constructor(parameters: ProjectsProjectFilterUpdatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "projects_project_filter_updated"
		},
		{
			name: "iterable",
			eventName: "projects_project_filter_updated"
		},
	]);
  }
}
export interface ProjectsProjectSortUpdatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	sortType: string; // Type of sorting applied, possible values are "last_edited", "alphabetical", "order_number" etc.
}

export type ProjectsProjectSortUpdatedParametersSpecific = Omit<
	ProjectsProjectSortUpdatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectsProjectSortUpdatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectsProjectSortUpdatedEventBuilder {
	constructor(private specificParameters: ProjectsProjectSortUpdatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectsProjectSortUpdatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectsProjectSortUpdatedParametersSpecific,
            ProjectsProjectSortUpdatedParameters,
			(params: ProjectsProjectSortUpdatedParameters) => ProjectsProjectSortUpdatedEvent
		>(this.specificParameters, projectsProjectSortUpdatedParametersGlobal, globalParams, (params) => new ProjectsProjectSortUpdatedEvent(params));
	}
}

/**
 * A user updated the sort for a project list.
 */
export class ProjectsProjectSortUpdatedEvent extends CraftnoteEvent<ProjectsProjectSortUpdatedParameters>{
  constructor(parameters: ProjectsProjectSortUpdatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "projects_project_sort_updated"
		},
		{
			name: "iterable",
			eventName: "projects_project_sort_updated"
		},
	]);
  }
}
export interface ProjectsProjectGroupingUpdatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	groupingType: string; // Type of grouping applied, possible values are "none", "status"
}

export type ProjectsProjectGroupingUpdatedParametersSpecific = Omit<
	ProjectsProjectGroupingUpdatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectsProjectGroupingUpdatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectsProjectGroupingUpdatedEventBuilder {
	constructor(private specificParameters: ProjectsProjectGroupingUpdatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectsProjectGroupingUpdatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectsProjectGroupingUpdatedParametersSpecific,
            ProjectsProjectGroupingUpdatedParameters,
			(params: ProjectsProjectGroupingUpdatedParameters) => ProjectsProjectGroupingUpdatedEvent
		>(this.specificParameters, projectsProjectGroupingUpdatedParametersGlobal, globalParams, (params) => new ProjectsProjectGroupingUpdatedEvent(params));
	}
}

/**
 * A user updated the project list's grouping option.
 */
export class ProjectsProjectGroupingUpdatedEvent extends CraftnoteEvent<ProjectsProjectGroupingUpdatedParameters>{
  constructor(parameters: ProjectsProjectGroupingUpdatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "projects_project_grouping_updated"
		},
		{
			name: "iterable",
			eventName: "projects_project_grouping_updated"
		},
	]);
  }
}
export interface ProjectsProjectFilterpaywallOpenedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type ProjectsProjectFilterpaywallOpenedParametersSpecific = Omit<
	ProjectsProjectFilterpaywallOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectsProjectFilterpaywallOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectsProjectFilterpaywallOpenedEventBuilder {
	constructor(private specificParameters: ProjectsProjectFilterpaywallOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectsProjectFilterpaywallOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectsProjectFilterpaywallOpenedParametersSpecific,
            ProjectsProjectFilterpaywallOpenedParameters,
			(params: ProjectsProjectFilterpaywallOpenedParameters) => ProjectsProjectFilterpaywallOpenedEvent
		>(this.specificParameters, projectsProjectFilterpaywallOpenedParametersGlobal, globalParams, (params) => new ProjectsProjectFilterpaywallOpenedEvent(params));
	}
}

/**
 * A user opens the project filters paywall
 */
export class ProjectsProjectFilterpaywallOpenedEvent extends CraftnoteEvent<ProjectsProjectFilterpaywallOpenedParameters>{
  constructor(parameters: ProjectsProjectFilterpaywallOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "projects_project_filterpaywall_opened"
		},
		{
			name: "iterable",
			eventName: "projects_project_filterpaywall_opened"
		},
	]);
  }
}
export interface ProjectsProjectstatusPaywallOpenedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type ProjectsProjectstatusPaywallOpenedParametersSpecific = Omit<
	ProjectsProjectstatusPaywallOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectsProjectstatusPaywallOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectsProjectstatusPaywallOpenedEventBuilder {
	constructor(private specificParameters: ProjectsProjectstatusPaywallOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectsProjectstatusPaywallOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectsProjectstatusPaywallOpenedParametersSpecific,
            ProjectsProjectstatusPaywallOpenedParameters,
			(params: ProjectsProjectstatusPaywallOpenedParameters) => ProjectsProjectstatusPaywallOpenedEvent
		>(this.specificParameters, projectsProjectstatusPaywallOpenedParametersGlobal, globalParams, (params) => new ProjectsProjectstatusPaywallOpenedEvent(params));
	}
}

/**
 * A basic user opened the manage project status paywall.
 */
export class ProjectsProjectstatusPaywallOpenedEvent extends CraftnoteEvent<ProjectsProjectstatusPaywallOpenedParameters>{
  constructor(parameters: ProjectsProjectstatusPaywallOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "projects_projectstatus_paywall_opened"
		},
		{
			name: "iterable",
			eventName: "projects_projectstatus_paywall_opened"
		},
	]);
  }
}
